import maskInput from 'vanilla-text-mask/dist/vanillaTextMask';
import checkoutValidation from './checkout-validation';
import Swiper from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
  let sPickupsPaymentTypes = '',
    debounceParams = {
      instance: null,
      timeout: 250
    };
  
  const debounce = (func) => {
    clearTimeout(debounceParams.instance);
    debounceParams.instance = setTimeout(
        () => {
          func();
        },
        debounceParams.timeout
    )
  };

  const phoneMask = ['+', '7', ' ', '(', /[9]/, /[0-9]/, /[0-9]/, ')', ' ', /[0-9]/, /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/, '-', /[0-9]/, /[0-9]/];
  const phoneInput = document.querySelector('.js-phone-input');
  const oOrderPromoAgreesNodes = document.querySelectorAll('.js-order__promo-agrees');

  if (phoneInput) {
    maskInput({
      inputElement: phoneInput,
      mask: phoneMask
    });

    if (oOrderPromoAgreesNodes) {
      phoneInput.addEventListener('input', ({target: oPhoneInput}) => {
        debounce(() => {
          checkShowUserAgreementCheckbox(oPhoneInput, oOrderPromoAgreesNodes);
        });
      });
    }
  }
  
  const checkout = document.querySelector('.checkout');
  const oPaymentSchedules = checkout?.querySelectorAll('.payment-schedule') || [];
  
  if (checkout) {
    window.checkout.setNewAddress = () => setAddressSelect();
    window.checkout.resetPoint = (pointType) => resetPoint(pointType);
    window.checkout.setAddressData = (addressId) => setAddressData(addressId);
    window.checkout.updateCheckoutWindowData = (country, regionObject, cityObject) => updateCheckoutWindowData(country, regionObject, cityObject);
    window.checkout.updateDeliveryPrice = (type, price) => updateDeliveryPrice(type, price);
    window.checkout.showPreloader = () => checkoutPreloader(true);
    window.checkout.hidePreloader = () => checkoutPreloader(false);
    if (!window.checkout.selectedValues) {
      window.checkout.selectedValues = {
        user: {
          profileId: "",
          name: "",
          lastName: "",
          phone: "",
          email: "",
          address: {
            city: {id: null, itemId: null, text: ''},
            street: {id: null, itemId: null, text: ''},
            house: {id: null, itemId: null, text: ''},
            flat: ""
          }
        },
        delivery: {
          deliveryId: "",
          pickupId: "",
          shopId: "",
          price: ""
        },
        paymentSystem: {
          id: "",
          sum: "",
          url: ""
        },
        comment: ''
      }
    }

    if (!window.checkout.paySystem) {
      window.checkout.paySystem = {
        checked: '',
        items: [
          {
            id: "6",
            name: "Онлайн оплата",
            url: "url"
          },
          {
            id: "14",
            name: "Оплата при получении",
            url: "url"
          }
        ]
      }
    }

    checkoutValidation();
    getFieldValues();
    resetAddressInputs();
    changeUserFields();

    const container = checkout.querySelector('#js-select');
    const selectText = checkout.querySelector('#js-select-open');
    const deliveryContent = checkout.querySelector('[data-content=\'delivery\']');
    const addressContent = checkout.querySelector('[data-content=\'delivery-address\']');
    const pointData = deliveryContent.querySelector("[data-content='delivery-pickup']");
    const shopData = deliveryContent.querySelector("[data-content='delivery-shop']");

    checkout.addEventListener('click', ({target}) => {
      const selectOpen = target.closest('#js-select-open');
      const selectContainer = target.closest('#js-select');

      if (selectOpen) {
        if (container.hasAttribute('data-open')) {
          container.removeAttribute('data-open');
        } else {
          container.setAttribute('data-open', '');
        }
      }

      if (selectContainer) {
        const button = target.closest('[data-select-id]');

        if (button) {
          selectContainer.removeAttribute('data-open');
          const selectId = button.getAttribute('data-select-id');

          setSelectText(selectId);
          setAddressData(selectId);
        }
      } else {
        container.removeAttribute('data-open');
      }
    });

    if (window.checkout && window.checkout.user) {
      const firstNameInput = document.querySelector('input#ch-first-name');
      const lastNameInput = document.querySelector('input#ch-last-name');
      const phoneInput = document.querySelector('input#ch-phone');
      const emailInput = document.querySelector('input#ch-email');

      for (const [key, value] of Object.entries(window.checkout.user)) {
        switch (key) {
          case 'firstName':
            firstNameInput.value = value;
            window.checkout.selectedValues.user.name = value;
            break;
          case 'lastName':
            lastNameInput.value = value;
            window.checkout.selectedValues.user.lastName = value;
            break;
          case 'registerPhone':
            phoneInput.value = value;
            window.checkout.selectedValues.user.phone = value;
            break;
          case 'email':
            emailInput.value = value;
            window.checkout.selectedValues.user.email = value;
            break;
        }
      }
    }

    if (window.checkout && window.checkout.address.default.city){
      setDefaultCity();
    }

    if (window.checkout && window.checkout.delivery) {
      if (window.checkout.delivery.items) {
        setAvailableDeliveries(window.checkout.delivery.items)
      }

      if (window.checkout.delivery.checked && window.checkout.delivery.checked.length) {
        const radioInput = deliveryContent.querySelector(`input#ch-d-${window.checkout.delivery.checked}`);
        radioInput.checked = true;

        switch (window.checkout.delivery.checked) {
          case 'pickup':
            addressContent.classList.add('m-hidden');
            shopData.classList.add('m-hidden');
            break;
          case 'shop':
            addressContent.classList.add('m-hidden');
            pointData.classList.add('m-hidden');
            break;
          default:
            addressContent.classList.remove('m-hidden');
            pointData.classList.add('m-hidden');
            shopData.classList.add('m-hidden');
            break;
        }

        window.checkout.selectedValues.delivery.deliveryId = window.checkout.delivery.items[window.checkout.delivery.checked].id;
        window.checkout.selectedValues.delivery.deliveryXmlId = window.checkout.delivery.items[window.checkout.delivery.checked].xmlId;
        window.checkout.selectedValues.delivery.price = window.checkout.delivery.items[window.checkout.delivery.checked].price;
      }
    }

    const addressOnLoad = selectText.getAttribute('data-selected-id')
    const isAddressEmpty = addressOnLoad === 'empty' || addressOnLoad === '';
    const isWindowAddressEmpty = window.checkout.address.checked ? window.checkout.address.checked === 'empty' : true;

    if (!isAddressEmpty && addressOnLoad) {
      setSelectText(addressOnLoad);
      setAddressData(addressOnLoad);
    } else if (!isWindowAddressEmpty && window.checkout.address.checked.length) {
      setSelectText(window.checkout.address.checked)
      setAddressData(window.checkout.address.checked)
    }

    const radioDeliveries = deliveryContent.querySelector('.ds-ch-radio-deliveries');
    const allDeliveriesRadio = radioDeliveries.querySelectorAll('input.radio');
    allDeliveriesRadio.forEach(deliveryRadioBtn => {
      changeDeliveryEvent(deliveryRadioBtn);

      const deliveryRadioBtnType = deliveryRadioBtn.id.slice(5);

      if (deliveryRadioBtn.checked) {
        switch (deliveryRadioBtnType) {
          case 'pickup':
            addressContent.classList.add('m-hidden');
            shopData.classList.add('m-hidden');
            break;
          case 'shop':
            addressContent.classList.add('m-hidden');
            pointData.classList.add('m-hidden');
            break;
          default:
            addressContent.classList.remove('m-hidden');
            pointData.classList.add('m-hidden');
            shopData.classList.add('m-hidden');
            break;
        }
        setAvailablePayment(deliveryRadioBtn);
        if (deliveryRadioBtnType !== 'empty'){
          window.checkout.selectedValues.delivery.deliveryId = window.checkout.delivery.items[deliveryRadioBtnType].id;
          window.checkout.selectedValues.delivery.deliveryXmlId = window.checkout.delivery.items[deliveryRadioBtnType].xmlId;
        }
      }
    });

    const addressDataInputs = addressContent.querySelectorAll('.input');
    const city = deliveryContent.querySelector('.input#ch-city');
    const deliveryInputs = [...addressDataInputs, city];
    
    deliveryInputs.forEach(input => {
      if (input) {
        input.addEventListener('change', () => {
          setAddressSelect();
        });
      }
    });

    const paymentContent = checkout.querySelector('[data-content="checkout-payment"]')
    const allPayments = paymentContent.querySelectorAll('input.radio');

    allPayments.forEach(paymentRadio => {
      const paymentData = window.checkout.paySystem.items.find(({id}) => id === paymentRadio.parentElement.getAttribute('data-id'));

      paymentRadio.addEventListener('change', () => {
        window.checkout.selectedValues.paymentSystem.id = paymentData ? paymentData.id : '';
        window.checkout.selectedValues.paymentSystem.url = paymentData ? paymentData.url : '';

        const selectedAddress = window.checkout.address.items.find(({id}) => id == window.checkout.address.checked);

        let countryForDelivery = window.dadataAddress.city.data.country || window.checkout.address.default.country,
          regionForDelivery = window.dadataAddress.city.data.region || window.checkout.address.default.region,
          regionFiasId = window.dadataAddress.city.data.region_fias_id || window.checkout.address.default.regionFiasId,
          cityForDelivery = window.dadataAddress.city.text || window.checkout.address.default.city,
          cityFiasId = 
            window.dadataAddress.city.data.city_fias_id 
            || window.dadataAddress.city.data.settlement_fias_id 
            || window.dadataAddress.city.data.area_fias_id 
            || window.dadataAddress.city.data.region_fias_id 
            || window.checkout.address.default.cityFiasId,
            cityZip = window.dadataAddress.city.data.postal_code ? window.dadataAddress.city.data.postal_code : window.checkout.selectedValues.user.address.zip;
        
        if (selectedAddress) {
          countryForDelivery = selectedAddress.delivery.country || countryForDelivery;
          regionForDelivery = selectedAddress.delivery.region || regionForDelivery;
          regionFiasId = selectedAddress.delivery.regionFiasId || regionFiasId;
          cityForDelivery = selectedAddress.delivery.city || cityForDelivery;
          cityFiasId = selectedAddress.delivery.fias || cityFiasId;
          cityZip = selectedAddress.delivery.zip || cityZip;
        }

        cityForDelivery = window.checkout.city.checked || cityForDelivery;

        updateCheckoutWindowData(
          countryForDelivery,
          {name: regionForDelivery, fias: regionFiasId},
          {name: cityForDelivery, fias: cityFiasId, zip: cityZip},
          false,
          false
        );
        window.checkout.deletePaymentError();
        getRecalculatedBasket(window.checkout.selectedValues.paymentSystem.id);
      })

      if (paymentRadio.checked) {
        window.checkout.selectedValues.paymentSystem.id = paymentData ? paymentData.id : '';
        window.checkout.selectedValues.paymentSystem.url = paymentData ? paymentData.url : '';
      }
    })

    setFirstDeliveryOrPayment('delivery');
  }

  if (window.innerWidth >= 1280) {
    let itemsSliders = document.getElementsByClassName('swiper-profile');

    Array.from(itemsSliders).forEach(function (slider) {
      const allSlides = slider.querySelectorAll('.swiper-slide');

      if (allSlides.length > 4) {
        let checkoutSlider = new Swiper(slider, {
          slidesPerView: 4,
          spaceBetween: 20,
          navigation: {
            nextEl: ".swiper-next",
            prevEl: ".swiper-prev"
          }
        });
        let buttonLeft = document.getElementsByClassName('swiper-prev')[0];
        let buttonRight = document.getElementsByClassName('swiper-next')[0];
        checkoutSlider.on('slideChange', function () {
          if (checkoutSlider.activeIndex == 0) {
            slider.style.marginLeft = 0;
            buttonRight.style.right = '10px';
          } else if (checkoutSlider.activeIndex == checkoutSlider.slides.length-4) {
            slider.style.marginRight = 0;
            buttonLeft.style.left = '10px';
          } else {
            slider.style.marginLeft = 'auto';
            slider.style.marginRight = 'auto';
            buttonLeft.style.left = 0;
            buttonRight.style.right = 0;
          }
        });
        buttonLeft.style.display = "block";
        buttonRight.style.display = "block";
      } else {
        let profileList = slider.querySelector('.profile__list');
        profileList.classList.add('select__list');
        slider.style.width = '100%';
      }
    });
  }

  function getFieldValues() {
    const contactInputs = ['ch-first-name', 'ch-last-name', 'ch-phone', 'ch-email'];
    const userContent = document.querySelector("[data-content='user']");
    let userInputs = [];
    contactInputs.forEach(inputName =>{
      userInputs.push(userContent.querySelector(`input#${inputName}`))
    })
    const commentField = document.getElementById('ch-comment');
    window.checkout.selectedValues.comment = commentField.value;

    userInputs.forEach(field => {
      let type = 'name';
      switch (field.id) {
        case 'ch-last-name':
          type = 'lastName';
          break;
        case 'ch-phone':
          type = 'phone';
          break;
        case 'ch-email':
          type = 'email';
          break;
      }
      window.checkout.selectedValues.user[type] = field.value;
    })
  }

  function resetAddressInputs() {
    const deliveryInputs = ['ch-city', 'ch-street', 'ch-house', 'ch-flat'];
    let addressInputs = [];
    deliveryInputs.forEach(inputName =>{
      addressInputs.push(document.querySelector(`input#${inputName}`))
    })
    addressInputs.forEach(input =>{
      input.value = ""
    })
  }

  function changeDeliveryEvent(deliveryRadioBtn) {
    deliveryRadioBtn.addEventListener('change', () => {
      const deliveryContent = checkout.querySelector('[data-content=\'delivery\']');
      const radioDeliveries = deliveryContent.querySelector('.ds-ch-radio-deliveries');
      const addressContent = checkout.querySelector('[data-content=\'delivery-address\']');
      const pointData = deliveryContent.querySelector("[data-content='delivery-pickup']");
      const shopData = deliveryContent.querySelector("[data-content='delivery-shop']");
      const deliveryType = deliveryRadioBtn.id.slice(5);
      const deliveryPrice = deliveryRadioBtn.parentElement.querySelector('.ds-delivery-price').textContent;
      const buttonSelectPoint = checkout.querySelector(`[data-content="delivery-pickup-open"]`);
      const buttonSelectShop = checkout.querySelector(`[data-content="delivery-shop-open"]`);
      const deliveryData = window.checkout.delivery.items[deliveryType];

      setAddressSelect();

      const errorElements = radioDeliveries.querySelectorAll('.ch-order__error');

      errorElements.forEach(oError => {
        oError.remove();
      });

      if (deliveryData && !deliveryData.deliveryIntervals) {
        document.querySelector('.ch-order__delivery-intervals-wrap')?.classList.add('m-hidden');
      }

      switch (deliveryType) {
        case 'pickup':
          addressContent.classList.add('m-hidden');
          buttonSelectShop?.classList.add('m-hidden');
          shopData.classList.add('m-hidden');

          if (window.checkout && window.checkout.selectedPickup && window.checkout.selectedPickup.id) {
            deliveryRadioBtn.setAttribute('data-payment', window.checkout.selectedPickup.paymentType);
            pointData.classList.remove('m-hidden');
          } else {
            buttonSelectPoint?.classList.remove('m-hidden');
          }
          break;
        case 'shop':
          addressContent.classList.add('m-hidden');
          buttonSelectPoint?.classList.add('m-hidden');
          pointData.classList.add('m-hidden');

          if (window.checkout && window.checkout.selectedShop && window.checkout.selectedShop.id) {
            deliveryRadioBtn.setAttribute('data-payment', window.checkout.selectedShop.paymentType);
            shopData.classList.remove('m-hidden');
          } else {
            buttonSelectShop?.classList.remove('m-hidden');
          }
          break;
        default:
          addressContent.classList.remove('m-hidden');
          pointData.classList.add('m-hidden');
          shopData.classList.add('m-hidden');
          buttonSelectPoint?.classList.add('m-hidden');
          buttonSelectShop?.classList.add('m-hidden');
          break;
      }

      setAvailablePayment(deliveryRadioBtn);
      updateCheckoutDeliveryPrice(deliveryPrice);

      if (deliveryData) {
        window.checkout.selectedValues.delivery.deliveryId = deliveryData.id;
        window.checkout.selectedValues.delivery.deliveryXmlId = deliveryData.xmlId;
        window.checkout.selectedValues.delivery.price = deliveryPrice;
      }

      setFirstDeliveryOrPayment('payment');
    });
  }

  function changeUserFields() {
    const userContent = document.querySelector("[data-content='user']");
    const firstName = userContent.querySelector('input#ch-first-name');
    const lastName = userContent.querySelector('input#ch-last-name');
    const phone = userContent.querySelector('input#ch-phone');
    const email = userContent.querySelector('input#ch-email');
    const userInputs = [firstName, lastName, phone, email];

    userInputs.forEach(field => {
      field.addEventListener('input', () => {
        let type = 'name';
        switch (field.id) {
          case 'ch-last-name':
            type = 'lastName';
            break;
          case 'ch-phone':
            type = 'phone';
            break;
          case 'ch-email':
            type = 'email';
            break;
        }
        window.checkout.selectedValues.user[type] = field.value;
      })
    })

    const commentField = document.getElementById('ch-comment');
    commentField.addEventListener('input', () => {
      window.checkout.selectedValues.comment = commentField.value;
    })
  }

  function setSelectText(selectAddressId) {
    const container = checkout.querySelector('#js-select');
    const selectText = checkout.querySelector('#js-select-open');

    const allButtons = container.querySelectorAll('[data-select-id]');
    const buttonSelected = container.querySelector(`[data-select-id='${selectAddressId}']`);

    allButtons.forEach(btn => btn.classList.remove('m-selected'));
    if (buttonSelected) {
      buttonSelected.classList.add('m-selected');
      selectText.innerHTML = buttonSelected.innerHTML;
      selectText.setAttribute('data-selected-id', selectAddressId);
    }
  }

  function setAddressData(addressId) {
    const selectedAddress = window.checkout.address.items.find(({id}) => id === addressId);
    const userContent = document.querySelector("[data-content='user']");
    const deliveryContent = document.querySelector("[data-content='delivery']");
    const addressContent = document.querySelector("[data-content='delivery-address']");
    const city = deliveryContent.querySelector('input#ch-city');
    const street = deliveryContent.querySelector('input#ch-street');
    const house = deliveryContent.querySelector('input#ch-house');
    const flat = deliveryContent.querySelector('input#ch-flat');
    const addressInputs = [city, street, house, flat];
    const radioDeliveries = deliveryContent.querySelector('.ds-ch-radio-deliveries');
    const pointData = deliveryContent.querySelector("[data-content='delivery-pickup']");
    const shopData = deliveryContent.querySelector("[data-content='delivery-shop']");


    if (selectedAddress) {
      const firstName = userContent.querySelector('input#ch-first-name');
      const lastName = userContent.querySelector('input#ch-last-name');
      const phone = userContent.querySelector('input#ch-phone');
      const email = userContent.querySelector('input#ch-email');
      const userInputs = [firstName, lastName, phone, email];

      userInputs.forEach(input => {
        input.value = '';
        removeError(input);
      });

      window.checkout.selectedValues.user = {
        profileId: selectedAddress.id,
        name: "",
        lastName: "",
        phone: "",
        email: "",
        address: {
          city: {id: null, itemId: null, text: ''},
          street: {id: null, itemId: null, text: ''},
          house: {id: null, itemId: null, text: ''},
          flat: "",
          fias: "",
          zip: ""
        }
      }

      addressInputs.forEach(input => {
        input.value = '';
        removeError(input);
      });

      resetPoint('pickup');
      resetPoint('shop');

      window.checkout.selectedValues.delivery = {
        deliveryId: "",
        pickupId: "",
        shopId: "",
        price: ""
      }

      resetNodeErrors(radioDeliveries);

      if (selectedAddress.delivery.city !== window.checkout.city.checked) {
        window.checkout.city.checked = selectedAddress.delivery.city;
        updateCheckoutOnProfileSelect(selectedAddress.delivery.country, selectedAddress.delivery.region, {name: selectedAddress.delivery.city, fias: selectedAddress.delivery.fias, zip: selectedAddress.delivery.zip}, false)
         .then(() => {
           if (selectedAddress.delivery) {
             setDeliveryData();
           }
           checkoutPreloader(false);
         })
         .catch(error => console.error(error));
      } else {
        if (selectedAddress.delivery) {
          setDeliveryData();
        }
      }

      if (selectedAddress.user) {
        for (const [key, value] of Object.entries(selectedAddress.user)) {
          switch (key) {
            case 'firstName':
              firstName.value = value;
              break;
            case 'lastName':
              lastName.value = value;
              break;
            case 'phone':
              phone.value = value;
              break;
            case 'email':
              email.value = value;
              break;
          }
        }

        window.checkout.selectedValues.user.name = selectedAddress.user.firstName ? selectedAddress.user.firstName : '';
        window.checkout.selectedValues.user.lastName = selectedAddress.user.lastName ? selectedAddress.user.lastName : '';
        window.checkout.selectedValues.user.phone = selectedAddress.user.phone ? selectedAddress.user.phone : '';
        window.checkout.selectedValues.user.email = selectedAddress.user.email ? selectedAddress.user.email : '';
      }
    }

    if (!selectedAddress && addressId === 'empty') {
      addressInputs.forEach(input => {
        input.value = '';
        removeError(input);
      });

      resetNodeErrors(radioDeliveries);

      window.checkout.selectedValues.user.profileId = "";
      window.checkout.selectedValues.user.address = {
        city: {id: null, itemId: null, text: ''},
        street: {id: null, itemId: null, text: ''},
        house: {id: null, itemId: null, text: ''},
        flat: "",
        fias: "",
        zip: ""
      };
      window.checkout.selectedValues.delivery = {
        deliveryId: "",
        pickupId: "",
        shopId: "",
        price: ""
      }

      setDefaultCity();

      if (window.checkout.city.checked !== window.checkout.address.default.city) {
        window.checkout.city.checked = window.checkout.address.default.city;
        updateCheckoutWindowData(
          window.checkout.address.default.country,
          {name: window.checkout.address.default.region, fias: window.checkout.address.default.regionFiasId},
          {name: window.checkout.address.default.city, fias: window.checkout.address.default.fias, zip: ''}
        );
      }

      resetPoint('pickup');
      resetPoint('shop');
      const radioUnselect = radioDeliveries.querySelector('.radio#ch-d-empty');
      radioUnselect.checked = true;

      updateCheckoutDeliveryPrice('0 ₽');
    }

    function setDeliveryData() {
      const radioInput = deliveryContent.querySelector(`input#ch-d-${selectedAddress.delivery.type}`);
      const buttonSelect = radioInput.parentElement.querySelector('button');
      const deliveryPrice = radioInput.parentElement.querySelector('.ds-delivery-price').textContent;
      radioInput.checked = true;

      switch (selectedAddress.delivery.type) {
        case 'pickup':
          addressContent.classList.add('m-hidden');
          shopData.classList.add('m-hidden');
          selectPoint(selectedAddress.delivery.id, 'pickup', buttonSelect);
          break;
        case 'shop':
          addressContent.classList.add('m-hidden');
          pointData.classList.add('m-hidden');
          selectPoint(selectedAddress.delivery.id, 'shop', buttonSelect);
          break;
        default:
          addressContent.classList.remove('m-hidden');
          pointData.classList.add('m-hidden');
          shopData.classList.add('m-hidden');
          break;
      }

      setAddressInput(selectedAddress.delivery);

      if (radioInput.hasAttribute("data-payment")) {
        const inputPaymentIds = radioInput.getAttribute("data-payment").split('_');
        checkPayment(inputPaymentIds);
      }

      updateCheckoutDeliveryPrice(deliveryPrice);

      window.checkout.selectedValues.delivery.deliveryId = window.checkout.delivery.items[selectedAddress.delivery.type].id;
      window.checkout.selectedValues.delivery.deliveryXmlId = window.checkout.delivery.items[selectedAddress.delivery.type].xmlId;
      window.checkout.selectedValues.delivery.price = deliveryPrice
      window.checkout.selectedValues.user.address.fias = selectedAddress.delivery.fias ? selectedAddress.delivery.fias : "";
      window.checkout.selectedValues.user.address.zip = selectedAddress.delivery.zip ? selectedAddress.delivery.zip : "";

      setFirstDeliveryOrPayment('payment');
    }

    function removeError(inputNode) {
      if (inputNode.classList.contains('error')) {
        inputNode.classList.remove('error');
        const errorNode = inputNode.nextElementSibling;
        inputNode.parentElement.removeChild(errorNode);
      }
    }

    function setAddressInput(address) {
      const citiesPopupOpen = document.querySelectorAll('.ds-popup-cities-open');

      for (const [key, value] of Object.entries(address)) {
        let newAddressObject = {
          id: null,
          itemId: value,
          name: value,
          text: value
        }
        switch (key) {
          case 'city':
            city.value = value;

            citiesPopupOpen.forEach(openButton => {
              openButton.innerHTML = 'г. ' + value;
            })

            if (address.region) {
              newAddressObject.data = {
                region: address.region
              }
            }

            if (address.fias)
              newAddressObject.data.city_fias_id = address.fias

            window.dadataAddress.city = newAddressObject;
            window.dadata.setItem('city', newAddressObject);
            window.checkout.selectedValues.user.address.city = newAddressObject;
            break;
          case 'street':
            street.value = value;
            window.dadataAddress.street = newAddressObject;
            window.dadata.setItem('street', newAddressObject);
            window.checkout.selectedValues.user.address.street = newAddressObject;
            break;
          case 'house':
            house.value = value;
            window.dadataAddress.house = newAddressObject;
            window.dadata.setItem('house', newAddressObject);
            window.checkout.selectedValues.user.address.house = newAddressObject;
            break;
          case 'flat':
            flat.value = value;
            window.dadataAddress.flat = value;
            window.dadata.setItem('flat', value);
            window.checkout.selectedValues.user.address.flat = value;
            break;
        }
      }
    }
  }

  function setDefaultCity(){
    const citiesPopupOpen = document.querySelectorAll('.ds-popup-cities-open');

    citiesPopupOpen.forEach(openButton => {
      openButton.innerHTML = window.checkout.address.default?.nameWithType || window.checkout.address.default.city;
    })

    const cityInput = document.querySelector('input#ch-city');

    cityInput.value = window.checkout.address.default.city;

    let newAddressObject = {
      id: window.checkout.address.default.cityFiasId,
      itemId: window.checkout.address.default.city,
      name: window.checkout.address.default.city,
      text: window.checkout.address.default.city
    }

    if (window.checkout.address.default.region) {
      newAddressObject.data = {
        region: window.checkout.address.default.region,
        postal_code: window.checkout.address.default.postalCode,
        city_fias_id: window.checkout.address.default.cityFiasId
      }
    }

    window.dadataAddress.city = newAddressObject;
    window.dadata.setItem('city', newAddressObject);
    window.checkout.selectedValues.user.address.city = newAddressObject;
  }

  function selectPoint(pointId, type, buttonSelect) {
    const deliveryContent = document.querySelector("[data-content='delivery']");
    const pointData = deliveryContent.querySelector(`[data-content='delivery-${type}']`);
    const pointTitle = pointData.querySelector(`[data-content='${type}-title']`);
    const pointAddress = pointData.querySelector(`[data-content='${type}-address']`);
    const paymentInput = document.querySelector("input#ch-d-".concat(type));
    let point = null;

    if (type === 'pickup') {
      point = window.checkout.pickupPoints.find(({id}) => id.toString() == pointId.toString());
      paymentInput.setAttribute('data-payment', point.paymentType);
    } else {
      point = window.checkout.shopsPoints.find(({storeXmlId}) => storeXmlId.toString() == pointId.toString());
      paymentInput.setAttribute('data-payment', point.paymentType);
    }

    if (point) {
      pointTitle.innerHTML = point.name;
      pointAddress.innerHTML = point.address;
      pointData.classList.remove('m-hidden');

      if (type === 'pickup') {
        window.checkout.selectedPickup = point;
        window.checkout.selectedValues.delivery.pickupId = point.id;
      } else {
        window.checkout.selectedShop = point;
        window.checkout.selectedValues.delivery.shopId = point.id;
      }

      const popup = document.querySelector(`.ds-popup-${type}`);
      const selectedPoint = popup.querySelector(`.ds-popup-${type}-point[data-id="${pointId}"]`);

      popup.querySelectorAll(`.ds-popup-${type}-point`).forEach(pointItem => {
        pointItem.removeAttribute('data-active');
      });

      selectedPoint.setAttribute('data-active', '');
      buttonSelect.classList.add('m-hidden');
    }
  }

  function resetPoint(pointType) {
    const popup = document.querySelector(`.ds-popup-${pointType}`);
    const pointData = document.querySelector(`[data-content='delivery-${pointType}']`);
    const pointTitle = pointData.querySelector(`[data-content='${pointType}-title']`);
    const pointAddress = pointData.querySelector(`[data-content='${pointType}-address']`);
    pointTitle.innerHTML = '';
    pointAddress.innerHTML = '';
    pointData.classList.add('m-hidden');

    if (pointType === 'pickup') {
      window.checkout.selectedPickup = null;
    } else {
      window.checkout.selectedShop = null;
    }
    
    popup.querySelectorAll(`.ds-popup-${pointType}-point`).forEach(pointItem => {
      pointItem.removeAttribute('data-active');
    });
  }

  function setAddressSelect() {
    const selectText = document.querySelector('#js-select-open');
    const selectContainer = document.querySelector('#js-select');
    const selectId = selectText.getAttribute('data-selected-id');
    const addressEmpty = selectContainer.querySelector('[data-select-id=\'empty\']');
    const street = document.querySelector('input#ch-street');

    if (selectId && selectId !== 'empty') {
      const allButtons = selectContainer.querySelectorAll('[data-select-id]');
      
      allButtons.forEach(btn => btn.classList.remove('m-selected'));

      addressEmpty.classList.add('m-selected');
      selectText.innerHTML = addressEmpty.innerHTML;
      selectText.setAttribute('data-selected-id', 'empty');
      window.checkout.selectedValues.user.profileId = '';
      street.value = '';
      
      for(let arAddress of window.checkout.address.items)
      {
        if(selectId == arAddress.id)
        {
          if (arAddress.delivery.zip && !empty(arAddress.delivery.zip))
            window.checkout.address.default.postalCode = arAddress.delivery.zip;

          break;
        }
      }
    }
  }

  function selectDateInterval({target: oTarget}) {
    const {dataset: {tab: sTabHash}} = oTarget;
    const oIntervalsTimeTab = document.getElementById(sTabHash + '-tab');
    const oFirstTimeInterval = oIntervalsTimeTab?.querySelector('.ch-order__delivery-interval');

    if (oFirstTimeInterval) {
      oFirstTimeInterval.click();
    }    
  }

  function selectTimeInterval(oInterval, oIntervalNode) {
    const oIntervalsContainer = oIntervalNode.closest('[data-content="delivery-intervals"]');
    const oSelectedIntervalNodes = oIntervalsContainer.querySelectorAll('.ch-order__delivery-interval.selected');

    oSelectedIntervalNodes.forEach(oElement => {
      oElement.classList.remove('selected');
    });

    oIntervalNode.classList.add('selected');

    window.checkout.selectedValues.delivery.interval = oInterval;
  }

  function setAvailableDeliveries(deliveriesList) {
    const radioDeliveries = document.querySelector('.ds-ch-radio-deliveries');
    let allTypes = [];
    let checkedTypes = [];

    for (const [type, delivery] of Object.entries(deliveriesList)) {
      let currentNode = radioDeliveries.querySelector(`input#ch-d-${type}`) ? radioDeliveries.querySelector(`input#ch-d-${type}`).parentElement : null;
      allTypes.push(type);

      if (!delivery.type) {
        delivery.type = type;
      }

      if (delivery.available) {
        setDeliveryData(currentNode, delivery)
      } else {
        hideDelivery(currentNode)
      }
    }

    const allDeliveries = radioDeliveries.querySelectorAll(`input`);

    allDeliveries.forEach(deliveryItem => {
      const curType = deliveryItem.id.slice(5);

      checkedTypes.push(curType);
    });

    const hiddenTypes = checkedTypes.filter(el => !allTypes.includes(el));

    hiddenTypes.forEach(type => {
      let currentNode = radioDeliveries.querySelector(`input#ch-d-${type}`) ? radioDeliveries.querySelector(`input#ch-d-${type}`).parentElement : null;
      hideDelivery(currentNode)
    });

    const allRadio = radioDeliveries.querySelectorAll('input.radio');

    allRadio.forEach(radioInput => {
      if (radioInput.checked) {
        let radio = radioInput;
        if (radioInput.parentElement.classList.contains('m-hidden')) {
          const emptyRadio = radioDeliveries.querySelector('input#ch-d-empty');
          if (emptyRadio) {
            emptyRadio.checked = true;
            radio = emptyRadio;
          }
        }

        const radioInputWrap = radioInput.closest('li.ch-order-radio');
        const deliveryContent = checkout.querySelector('[data-content=\'delivery\']');
        const addressContent = checkout.querySelector('[data-content=\'delivery-address\']');
        const addressContentWrap = addressContent.closest('li.ch-order__address-wrap');
        const pointData = deliveryContent.querySelector("[data-content='delivery-pickup']");
        const shopData = deliveryContent.querySelector("[data-content='delivery-shop']");

        switch (radio.id.slice(5)) {
          case "pickup":
            addressContent.classList.add('m-hidden');
            shopData.classList.add('m-hidden');
            break;
          case "shop":
            addressContent.classList.add('m-hidden');
            pointData.classList.add('m-hidden');

            if (window.site.isElisSite && window.site.isProd)
              ym(window.site.iYandexTrackerId, 'reachGoal', 'delivery_from_shop');

            break;
          default:
            addressContent.classList.remove('m-hidden');
            pointData.classList.add('m-hidden');
            shopData.classList.add('m-hidden');
            break;
        }
      }
    })

    updatePrice();
    updateDeliveryIntervals(deliveriesList);

    function setDeliveryData(itemNode, itemData) {
      if (itemNode && itemData) {
        itemNode.classList.remove('m-hidden');
        const input = itemNode.querySelector('input');
        const text = itemNode.querySelector('.ds-delivery-text');
        const time = itemNode.querySelector('.ds-delivery-time');
        const price = itemNode.querySelector('.ds-delivery-price');
        let paymentsId = (itemData.type === 'pickup' && sPickupsPaymentTypes.length > 0 ? sPickupsPaymentTypes : itemData.paySystem.join('_'));

        if (itemData.type === 'pickup' && !empty(window.checkout.selectedPickup)) {
          paymentsId = window.checkout.selectedPickup.paymentType;

          if (itemData.price != 0 && window.checkout.selectedPickup.price) {
            itemData.price = window.checkout.selectedPickup.price;
            itemData.priceFormatted = window.checkout.selectedPickup.priceFormatted;
          }
        }

        if (itemData.type === 'shop' && !empty(window.checkout.selectedShop)) {
          paymentsId = window.checkout.selectedShop.paymentType;

          if (window.checkout.selectedShop.deliveryPeriod) {
            itemData.period = window.checkout.selectedShop.deliveryPeriod;
          }
        }

        input.setAttribute('data-payment', paymentsId);

        if (itemData.price || itemData.priceFormatted && price) {
          price.innerHTML = '';
          price.innerHTML = itemData.priceFormatted ? itemData.priceFormatted : itemData.price;
        }

        if (itemData.description && text) {
          text.innerHTML = '';
          text.innerHTML = itemData.description;
        }

        if (itemData.period && time) {
          time.innerHTML = '';
          time.innerHTML = itemData.period;
        }
      } else if (itemData) {
        const paymentsId = (itemData.type === 'pickup' && sPickupsPaymentTypes.length > 0 ? sPickupsPaymentTypes : itemData.paySystem.join('_'));
        const newDelivery = document.createElement('li');

        newDelivery.classList.add('ch-order-radio');

        const newDeliveryPrice = itemData.priceFormatted ? itemData.priceFormatted : itemData.price;

        newDelivery.innerHTML =
           `
                        <input class="radio" type="radio" name="delivery" id="ch-d-${itemData.type}" data-payment="${paymentsId}">
                        <label class="field-label ch-order-radio__label" for="ch-d-${itemData.type}">${itemData.name ? itemData.name : ''}</label>
                        <div class="ch-order-radio__info">
                          <p class="ch-order-radio__text ds-delivery-text">${itemData.description ? itemData.description : ''}</p>
                          <p class="ch-order-radio__price">
                            <span class="ds-delivery-price">${newDeliveryPrice ? newDeliveryPrice : ''}</span>
                            <span class="ds-delivery-time">${itemData.period ? itemData.period : ''}</span>
                          </p>
                        </div>
        `
        const deliveryErrorNode = radioDeliveries.querySelector('.ch-order__error');
        if (deliveryErrorNode) {
          deliveryErrorNode.before(newDelivery);
        } else {
          radioDeliveries.appendChild(newDelivery);
        }

        changeDeliveryEvent(newDelivery.querySelector('input'));
      }
    }

    function hideDelivery(itemNode) {
      if (itemNode) {
        itemNode.classList.add('m-hidden');
      }
    }

    function updateDeliveryIntervals(oDeliveriesList) {
      const oDeliveryIntervalsWrap = document.querySelector('.ch-order__delivery-intervals-wrap');
      const sSelectedDeliveryXmlId = window.checkout.selectedValues.delivery.deliveryXmlId ?? null;

      if (!sSelectedDeliveryXmlId) {
        oDeliveryIntervalsWrap.classList.add('m-hidden');
        return;
      }

      const oSelectedDeliveryRadio = document.querySelector(`.ch-order-radio[data-delivery="ch-d-${sSelectedDeliveryXmlId}"]`);
      const oSelectedDeliveryData = oDeliveriesList[sSelectedDeliveryXmlId];
      const oDeliveryIntervals = oDeliveryIntervalsWrap.querySelector('[data-content="delivery-intervals"]');
      const oDeliveryIntervalsDates = oDeliveryIntervals.querySelector('[data-content="delivery-intervals-dates"]');
      const oDeliveryIntervalsTimes = oDeliveryIntervals.querySelector('[data-content="delivery-intervals-times"]');

      if (
        oSelectedDeliveryRadio
        && oSelectedDeliveryData
        && oSelectedDeliveryData.deliveryIntervals
      ) {
        const sDeliveryIntervalsHash = oSelectedDeliveryData.deliveryIntervalsHash;
        const sCurrentDeliveryIntervalsHash = oDeliveryIntervals.dataset.hash || null;
        const isEqualIntervals = sDeliveryIntervalsHash === sCurrentDeliveryIntervalsHash;

        if (!isEqualIntervals) {
          let arIntervalsDateNodes = [],
            arIntervalsDateTimeNodes = [];

          oDeliveryIntervalsDates.replaceChildren();
          oDeliveryIntervalsTimes.replaceChildren();

          Object.entries(oSelectedDeliveryData.deliveryIntervals).forEach(([sDateHash, arIntervals], iIndex) => {
            const oIntervalDateNode = document.createElement('div');

            oIntervalDateNode.classList.add('ch-order__delivery-interval');
            oIntervalDateNode.dataset.tab = sDateHash;
            oIntervalDateNode.dataset.tabHeader = '';
            oIntervalDateNode.textContent = arIntervals[0].date_format;

            if (iIndex === 0) {
              oIntervalDateNode.classList.add('active');
            }

            oIntervalDateNode.addEventListener('click', selectDateInterval);

            arIntervalsDateNodes.push(oIntervalDateNode);
          });

          Object.entries(oSelectedDeliveryData.deliveryIntervals).forEach(([sDateHash, arIntervals], iDateIndex) => {
            const oIntervalsTimeTab = document.createElement('div');
            const oIntervalsTimeWrap = document.createElement('div');
            
            oIntervalsTimeTab.id = sDateHash + '-tab';
            oIntervalsTimeTab.dataset.tabContent = '';
            oIntervalsTimeWrap.classList.add('ch-order__delivery-intervals');

            if (iDateIndex !== 0) {
              oIntervalsTimeTab.style.display = 'none';
            }

            arIntervals.forEach((oInterval, iTimeIndex) => {
              const oTimeNode = document.createElement('div');
              const sIntervalTime = oInterval.from + '-' + oInterval.to;

              oTimeNode.classList.add('ch-order__delivery-interval');
              oTimeNode.textContent = sIntervalTime;

              oTimeNode.addEventListener('click', () => {
                selectTimeInterval(oInterval, oTimeNode);
              });

              if (iDateIndex === 0 && iTimeIndex === 0) {
                oTimeNode.classList.add('selected');

                window.checkout.selectedValues.delivery.interval = oInterval;
              }

              oIntervalsTimeWrap.append(oTimeNode);
            });

            oIntervalsTimeTab.append(oIntervalsTimeWrap);
            arIntervalsDateTimeNodes.push(oIntervalsTimeTab);
          });

          oDeliveryIntervalsDates.append(...arIntervalsDateNodes);
          oDeliveryIntervalsTimes.append(...arIntervalsDateTimeNodes);

          oDeliveryIntervals.dataset.hash = oSelectedDeliveryData.deliveryIntervalsHash;

          window.tabs.bindTabEvents(oDeliveryIntervals);
        }

        oDeliveryIntervalsWrap.classList.remove('m-hidden');
      } else {
        oDeliveryIntervalsWrap.classList.add('m-hidden');
      }
    }

    function updatePrice() {
      const radioItems = radioDeliveries.querySelectorAll('input');
      let selectedRadioItem = null;
      radioItems.forEach(item => {
        if (item.checked) {
          selectedRadioItem = item;
        }
      })
      if (selectedRadioItem) {
        const priceNode = selectedRadioItem.parentElement.querySelector('.ds-delivery-price');
        if (priceNode) {
          const deliveryPrice = priceNode.textContent;
          updateCheckoutDeliveryPrice(deliveryPrice);
        } else {
          updateCheckoutDeliveryPrice("0 ₽");
        }
      }
    }
  }

  function getAvailableDeliveries(regionData, cityData, fias = '', zip = '', regionFias = '') {
    const region = regionData ? regionData : '';
    const city = cityData ? cityData : '';
    const paymentSystemId = window.checkout.selectedValues.paymentSystem.id || 6;

    if (window.BX) {
      return window.BX.ajax.runComponentAction('ega:order', 'getDeliveryList',
         {
           mode: 'class',
           data: {
             region,
             city,
             paymentSystemId,
             fias,
             zip,
             regionFias
           },
         })
    } else {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            status: 'success',
            data: {
              success: true,
              deliveries: {
                courier: {
                  id: "20",
                  available: true,
                  period: "4-6 дня",
                  priceFormatted: "350 ₽",
                  price: "350",
                  text: "Доставим домой в удобное время.",
                  paySystem: ['6', '14']
                },
                pickup: {
                  id: "19",
                  available: false,
                  period: "4-6 дня",
                  priceFormatted: "402 ₽",
                  price: "402",
                  paySystem: ['6', '14']
                },
                shop: {
                  id: '2',
                  available: true,
                  period: 'От 7 дней',
                  priceFormatted: 'Бесплатно',
                  price: '0',
                  paySystem: ['6']
                },
                post: {
                  id: '2',
                  available: true,
                  period: 'От 8 дней',
                  priceFormatted: '500 ₽',
                  price: '500',
                  description: "Доставим почтой",
                  name: 'Почтой России',
                  paySystem: ['6']
                }
              },
              checked: 'courier'
            }
          });
        }, 2000)

      });
    }
  }

  function setAvailablePayment(deliveryInput) {
    const availablePayments = deliveryInput.getAttribute('data-payment');
    if (availablePayments) {
      const paymentsId = availablePayments.split('_');
      checkPayment(paymentsId);
    }
  }

  function checkPayment(ids) {
    const paymentItems = document.querySelector('[data-content="checkout-payment"]');
    if (!paymentItems) return;

    const paySystemItems = window.checkout?.paySystem?.items || [];
    const selectedPayment = window.checkout?.selectedValues?.paymentSystem || {};

    const paymentConfigs = [
        { inputId: 'ch-p-online',        fallbackIds: (m) => [m.offline, m.onlineSplit, m.onlineSbp] },
        { inputId: 'ch-p-offline',       fallbackIds: (m) => [m.online, m.onlineSplit, m.onlineSbp] },
        { inputId: 'ch-p-onlineSplit',   fallbackIds: (m) => [m.online, m.offline, m.onlineSbp] },
        { inputId: 'ch-p-onlineSbp',     fallbackIds: (m) => [m.online, m.offline, m.onlineSplit] },
        { inputId: 'ch-p-onlineYookassa',fallbackIds: (m) => [m.online, m.offline, m.onlineSplit] },
        { inputId: 'ch-p-CConline',      fallbackIds: (m) => [m.online, m.offline, m.onlineSplit] },
        { inputId: 'ch-p-yandexPay',     fallbackIds: (m) => [m.online, m.offline, m.onlineSplit] },
        { inputId: 'ch-p-yandexSplit',   fallbackIds: (m) => [m.online, m.offline, m.onlineSplit] },
        { inputId: 'ch-p-dolyameSplit',    fallbackIds: (m) => [m.online, m.offline, m.onlineSplit] }
    ];

    const elements = {};
    const idMap = {};
    for (const cfg of paymentConfigs) {
        const input = paymentItems.querySelector(`input#${cfg.inputId}`);
        const parent = input ? input.parentElement : null;
        elements[cfg.inputId] = { input, parent };
        idMap[cfg.inputId] = parent ? parent.getAttribute('data-id') : null;
    }

    for (const key in elements) {
        if (elements[key].input) {
            elements[key].input.checked = false;
        }
    }

    for (const cfg of paymentConfigs) {
        const { parent } = elements[cfg.inputId];
        const currentId = idMap[cfg.inputId];
        if (!parent) continue;

        const isAvailable = currentId && ids.includes(currentId);

        if (!isAvailable) {
            parent.classList.add('m-hidden');
            const fallbackIds = cfg.fallbackIds(idMap);
            const payData = paySystemItems.find(({ id }) => fallbackIds.includes(id));
            selectedPayment.id = payData ? payData.id : '';
            selectedPayment.url = payData ? payData.url : '';
        } else {
            parent.classList.remove('m-hidden');
        }
    }
  }

  function checkoutPreloader(isShow = true, isShowSkeleton = false) {
    const checkoutForm = document.querySelector('.ds-checkout-form');
    const checkoutAddressSelect = checkoutForm.querySelector('#js-select-open');
    const checkoutDeliveries = document.querySelector('.ds-ch-radio-deliveries');
    const checkoutPayment = document.querySelector("[data-content='checkout-payment']");
    const checkoutSubmit = document.querySelector(".ds-checkout-submit");
    const allInputs = checkoutForm.querySelectorAll('.input, .radio');

    if (isShow) {
      allInputs.forEach(input => {
        if (input) {
          input.setAttribute('disabled', '');
        }
      })

      if (isShowSkeleton) {
        if (checkoutDeliveries) {
          checkoutDeliveries.querySelectorAll('.ch-order-radio, .ch-order__address-wrap > [data-content="delivery-address"]').forEach(oRadio => {
            oRadio.classList.add('skeleton');
          });
        }
  
        if (checkoutPayment) {
          checkoutPayment.querySelectorAll('.ch-order-radio').forEach(oRadio => {
            oRadio.classList.add('skeleton');
          });
        }
      }

      if (checkoutSubmit) {
        checkoutSubmit.setAttribute('disabled', '');
      }

      if (checkoutAddressSelect) {
        checkoutAddressSelect.setAttribute('disabled', '');
      }
    } else {
      allInputs.forEach(input => {
        if (input) {
          input.removeAttribute('disabled');
        }
      })

      if (isShowSkeleton) {
        if (checkoutDeliveries) {
          checkoutDeliveries.querySelectorAll('.ch-order-radio, .ch-order__address-wrap > [data-content="delivery-address"]').forEach(oRadio => {
            oRadio.classList.remove('skeleton');
          });
        }

        if (checkoutPayment) {
          checkoutPayment.querySelectorAll('.ch-order-radio').forEach(oRadio => {
            oRadio.classList.remove('skeleton');
          });
        }
      }

      if (checkoutSubmit) {
        checkoutSubmit.removeAttribute('disabled');
      }

      if (checkoutAddressSelect) {
        checkoutAddressSelect.removeAttribute('disabled');
      }
    }
  }

  function updatePickupPopup(city, region, resetPoints, fias = '', zip = '') {
    sPickupsPaymentTypes = '';

    if (window.popupPickup && window.popupPickup.showPreloader) {
      window.popupPickup.showPreloader();
    }
    getAvailablePickupPoints(city, region, fias, zip)
       .then(result => {
         if (result.status === 'success' && result.data.success) {
           window.checkout.pickupPoints = result.data.pickupPoints;
           window.checkout.updatePickupPopup(result.data.pickupPoints);

           if (window.popupPickup && window.popupPickup.resetSearch) {
             window.popupPickup.resetSearch();
           }

           if (resetPoints) {
             window.checkout.resetPoint('pickup')
           }

           const oPickupDeliveryBtn = checkout.querySelector('input#ch-d-pickup[type="radio"]');
           sPickupsPaymentTypes = result.data.paymentTypes.join('_');

           if (oPickupDeliveryBtn && result.data.paymentTypes.length > 0) {
            oPickupDeliveryBtn.dataset.payment = sPickupsPaymentTypes;
           }
         }

         if (window.popupPickup && window.popupPickup.hidePreloader) {
           window.popupPickup.hidePreloader();
         }
       })
       .catch(error => {
         if (window.popupPickup && window.popupPickup.hidePreloader) {
           window.popupPickup.hidePreloader()
         }
       })

    function getAvailablePickupPoints(city, region, fias, zip) {
      if (window.BX) {
        return window.BX.ajax.runComponentAction('ega:order', 'getPickupPoints',
           {
             mode: 'class',
             data: {
               region,
               city,
               fias,
               zip
             },
           })
      } else {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve({
              status: 'success',
              data: {
                success: true,
                pickupPoints: [
                  {
                    id: '1003062711',
                    name: 'На Хорошёвском шоссе 27',
                    address: 'Хорошёвское ш., 27',
                    workTime: 'Пн-Пт 10:00-21:00',
                    coords: [55.77923865906552, 37.52356959153274],
                    priceFormatted: '300 ₽',
                    price: '300',
                    typeText: 'Пункт выдачи заказа',
                    providerKeyText: "СДЭК"
                  },
                  {
                    id: '1003062714',
                    name: 'ТРЦ "Мозаика"',
                    address: 'ул, 7-я Кожуховская ул., 9 ТРЦ "Мозаика"',
                    workTime: 'Пн-Пт 10:00-20:00, Сб-Вс 10:00-18:00',
                    coords: [55.716468154586934, 37.6731217461949],
                    priceFormatted: '300 ₽',
                    price: '300',
                    typeText: 'Пункт выдачи заказа',
                    providerKeyText: "СДЭК"
                  },
                  {
                    id: '1003062715',
                    name: 'ТРЦ Columbus',
                    address: 'Кировоградская ул., 13А ТРЦ Columbus',
                    workTime: 'Пн-Пт 10:00-20:00, Сб-Вс 10:00-18:00',
                    coords: [55.6116990331495, 37.60723530006875],
                    priceFormatted: '300 ₽',
                    price: '300',
                    typeText: 'Пункт выдачи заказа',
                    providerKeyText: "СДЭК"
                  }
                ]
              }
            });
          }, 2000)

        });
      }
    }
  }

  function updateShopsPopup(cityObject, resetPoints) {
    const shopDeliveryTime = document.querySelector('[data-delivery="ch-d-shop"] .ds-delivery-time');
    const shopsPopupFilter = document.querySelector('[data-popup-type="shops"] .popup-filter');

    if (window.popupShop && window.popupShop.showPreloader) {
      window.popupShop.showPreloader();
    }
    
    getAvailableShopsPoints(cityObject)
       .then(result => {
          let {data} = result;

          if (result.status === 'success' && data.success) {
          
            data.shopsPoints.map((point) => point.paymentType = point.paymentType || window.checkout.delivery.items.shop.paySystem.join('_'))

            if (!window.checkout.selectedShop) {
              if (data.shopsPoints.some((el) => el.clickAndCollect === true)) {
                if (shopDeliveryTime)
                  shopDeliveryTime.innerText = 'Забрать через 2 часа';
  
                if (shopsPopupFilter)
                  shopsPopupFilter.style.display = 'block';
              } else if (shopsPopupFilter) {
                shopsPopupFilter.style.display = 'none';
              }
            }

            window.checkout.shopsPoints = data.shopsPoints;
            window.checkout.updateShopsPopup(data.shopsPoints);

            if (window.popupShop && window.popupShop.resetSearch) {
              window.popupShop.resetSearch();
            }

            if (resetPoints) {
              window.checkout.resetPoint('shop')
            }
          }
          if (window.popupShop && window.popupShop.hidePreloader) {
            window.popupShop.hidePreloader();
          }
       })
       .catch(error => {
         if (window.popupShop && window.popupShop.hidePreloader) {
           window.popupShop.hidePreloader();
         }
       })

    function getAvailableShopsPoints(cityObject) {
      let data = {
        isApishipDelivery: window.checkout.delivery.items.shop?.isApishipDelivery
      };

      if (cityObject.id) {
        data.id = cityObject.id;
      } else {
        data.name = cityObject.name;
      }

      if (window.BX) {
        return window.BX.ajax.runComponentAction('ega:order', 'getShopPoints',
           {
             mode: 'class',
             data
           })
      } else {
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve({
              status: 'success',
              data: {
                success: true,
                shopsPoints: [
                  {
                    id: '2003062711',
                    name: 'ТРЦ "Гранд Юг"',
                    address: 'ул. Кировоградская, д. 15, ТРЦ «Гранд Юг»',
                    workTime: 'Пн-Вс 10:00-21:00',
                    coords: [56.010233, 37.859322]
                  },
                  {
                    id: '2003062714',
                    name: 'ТРЦ "Мозаика"',
                    address: 'ул, 7-я Кожуховская ул., 9 ТРЦ "Мозаика"',
                    workTime: 'Пн-Пт 10:00-20:00, Сб-Вс 10:00-18:00',
                    coords: [55.716468154586934, 37.6731217461949]
                  },
                  {
                    id: '2003062715',
                    name: 'ТРЦ Columbus',
                    address: 'Кировоградская ул., 13А ТРЦ Columbus',
                    workTime: 'Пн-Пт 10:00-20:00, Сб-Вс 10:00-18:00',
                    coords: [55.6116990331495, 37.60723530006875]
                  }
                ]
              }
            });
          }, 2000)

        });
      }
    }
  }

  function updateCheckoutWindowData(country, regionObject, cityObject, resetPoints = true, resetAddress = true) {
    checkoutPreloader();
    const newCity = (cityObject && cityObject.name !== window.checkout.address.default.city && cityObject.name !== window.checkout.city.checked);
    const { name: regionName = '', fias: regionFias = '' } = (
        typeof regionObject === 'object' && regionObject !== null 
            ? regionObject 
            : { name: regionObject || '' }
    );
    
    if (country && country !== window.checkout.address.default.country) {
      const newCountry = window.checkout.countries[country];
      
      if (newCountry) {
        window.checkout.updateCountry(newCountry, regionName, cityObject.name)
      }
    }

    getAvailableDeliveries(regionName, cityObject.name, cityObject.fias, cityObject.zip, regionFias)
       .then(result => {

         if (result.status === 'success' && result.data.success) {
           if (result.data) {
             if (result.data.deliveries) {
               setAvailableDeliveries(result.data.deliveries);
               window.checkout.delivery.items = result.data.deliveries;
             }

             if (result.data.checked) {
               window.checkout.deleteDeliveryError();
               window.checkout.delivery.checked = result.data.checked;
             }

             if (result.data.render_departures) {
              updateDeparturesBlock(result.data.departures);
             }
           }
         }

         checkoutPreloader(false);
         checkAvailableDeliveries(result.data.deliveries, newCity);
         window.citiesPopup.endLoadingData();
       })
       .catch(error => {
         console.group('getAvailableDeliveries');
         console.error(error);
         console.groupEnd();
         checkoutPreloader(false);
         window.citiesPopup.endLoadingData();
       })

    updatePickupPopup(cityObject.name, regionName, resetPoints, cityObject.fias, cityObject.zip)
    updateShopsPopup(cityObject, resetPoints)

    if (window.dadata.resetAddressInputs && resetAddress) {
      window.dadata.resetAddressInputs();
    }

    return new Promise(resolve => {
      resolve()
    })
  }

  function updateCheckoutDeliveryPrice(price) {
    const priceNode = document.getElementById('deliveryPrice');
    priceNode.innerHTML = price;
    window.checkout.selectedValues.delivery.price = price;
    updateCheckoutTotalPrice();
  }

  function updateCheckoutTotalPrice() {
    const sumPrice = (document.getElementById('checkoutSum') ? document.getElementById('checkoutSum').textContent : '');
    const salePrice = (document.getElementById('checkoutSale') ? document.getElementById('checkoutSale').textContent : '');
    const bonusPrice = (document.getElementById('checkoutBonus') ? document.getElementById('checkoutBonus').textContent : '');
    const deliveryPrice = (document.getElementById('deliveryPrice') ? document.getElementById('deliveryPrice').textContent : '');
    const promocodePrice = (document.getElementById('promocodeDiscount') ? document.getElementById('promocodeDiscount').textContent : '');
    const totalPrice = (document.getElementById('checkoutTotal'));

    let sum = (getNumber(sumPrice) - getNumber(salePrice) - getNumber(bonusPrice) - getNumber(promocodePrice));

    if (deliveryPrice.toLowerCase() !== 'бесплатно') {
      sum = (sum + getNumber(deliveryPrice));
    }

    totalPrice.innerHTML = moneyFormat(sum) + ' ₽';
    window.checkout.selectedValues.paymentSystem.sum = moneyFormat(sum) + ' ₽';
    updatePaymentSchedules(sum);

    function getNumber(str) {
      const number = parseFloat(str.replace(/[^0-9.]/g, ''));

      return (number ? number : 0);
    }
  }

  function moneyFormat(price) {
    const value = price.toString();
    let slicedValue = [];
    let moneyValue = '';
    const counter = Math.ceil(value.length / 3);

    for (let i = counter; i > 0; i--) {
      let start = value.length - 3 * i;
      let end = value.length - 3 * i + 3;

      if (start < 0) {
        start = 0
      }

      slicedValue.push(value.slice(start, end));
    }

    for (let i = 0; i < counter; i++) {
      moneyValue += i === counter - 1 ? slicedValue[i] : slicedValue[i] + ' ';
    }

    return moneyValue
  }

  function updateDeliveryPrice(type, price) {
    const selectedRadioItem = document.querySelector(`input.radio#ch-d-${type}`);

    if (selectedRadioItem) {
      const priceNode = selectedRadioItem.parentElement.querySelector('.ds-delivery-price');

      if (priceNode) {
        priceNode.innerHTML = price;
        updateCheckoutDeliveryPrice(price);
      }
    }
  }

  function checkAvailableDeliveries(deliveriesList, newCity = false) {
    var isDeliveryNotAvailable = false;
    var paymentItems = document.querySelector('[data-content=\'checkout-payment\']');
    var deliveryNotAvailableText = document.querySelector('.delivery-not-available');
    var orderAddress = document.querySelector('.ch-order__address');
    var checkoutSubmit = document.querySelector(".ds-checkout-submit");

    for (const [type, delivery] of Object.entries(deliveriesList)) {
      if (delivery.available) {
        isDeliveryNotAvailable = true;
      }
    }

    if (!isDeliveryNotAvailable) {
      checkoutSubmit.setAttribute('disabled', '');
      paymentItems.style.display = 'none';
      orderAddress.style.display = 'none';
      deliveryNotAvailableText.style.display = '';
    } else {
      checkoutSubmit.removeAttribute('disabled');
      paymentItems.style.display = '';
      orderAddress.style.display = '';
      deliveryNotAvailableText.style.display = 'none';
    }

    if (newCity)
      setFirstDeliveryOrPayment('delivery');
  }

  function updateCheckoutOnProfileSelect(country, region, cityObject, resetPoints = true, resetAddress = true) {
    checkoutPreloader();

    if (country && country !== window.checkout.address.default.country) {
      const newCountry = window.checkout.countries[country];

      if (newCountry) {
        window.checkout.updateCountry(newCountry, region, cityObject.name)
      }
    }

    return new Promise(function (resolve, reject) {
      getAvailableDeliveries(region, cityObject.name, cityObject.fias, cityObject.zip)
          .then(result => {
            if (result.status === 'success' && result.data.success) {
              if (result.data) {
                if (result.data.deliveries) {
                  setAvailableDeliveries(result.data.deliveries);
                  window.checkout.delivery.items = result.data.deliveries;
                }

                if (result.data.checked) {
                  window.checkout.deleteDeliveryError();
                  window.checkout.delivery.checked = result.data.checked;
                }
              }
            }

            checkAvailableDeliveries(result.data.deliveries);
            window.citiesPopup.endLoadingData();
          })
          .catch(error => {
            console.group('getAvailableDeliveries');
            console.error(error);
            console.groupEnd();
            checkoutPreloader(false);
            window.citiesPopup.endLoadingData();
          })

      updateShopsPopupOnProfileSelect(cityObject, resetPoints)
      updatePickupPopupOnProfileSelect(cityObject.name, region, resetPoints, cityObject.fias, cityObject.zip)
          .then(() => resolve())
          .catch(error => reject(error));

      if (window.dadata.resetAddressInputs && resetAddress) {
        window.dadata.resetAddressInputs();
      }
    });
  }

  function updatePickupPopupOnProfileSelect(city, region, resetPoints, fias = '', zip = '') {
    return new Promise(function (resolve, reject) {
      if (window.popupPickup && window.popupPickup.showPreloader) {
        window.popupPickup.showPreloader();
      }
      getAvailablePickupPoints(city, region, fias, zip)
          .then(result => {
            if (result.status === 'success' && result.data.success) {
              window.checkout.pickupPoints = result.data.pickupPoints;
              window.checkout.updatePickupPopup(result.data.pickupPoints);

              if (window.popupPickup && window.popupPickup.resetSearch) {
                window.popupPickup.resetSearch();
              }

              if (resetPoints) {
                window.checkout.resetPoint('pickup')
              }
            }

            if (window.popupPickup && window.popupPickup.hidePreloader) {
              window.popupPickup.hidePreloader();
            }

            resolve();
          })
          .catch(error => {
            if (window.popupPickup && window.popupPickup.hidePreloader) {
              window.popupPickup.hidePreloader()
            }
            reject(error);
          })

      function getAvailablePickupPoints(city, region, fias, zip) {
        if (window.BX) {
          return window.BX.ajax.runComponentAction('ega:order', 'getPickupPoints',
              {
                mode: 'class',
                data: {
                  region,
                  city,
                  fias,
                  zip
                },
              })
        } else {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve({
                status: 'success',
                data: {
                  success: true,
                  pickupPoints: [
                    {
                      id: '1003062711',
                      name: 'На Хорошёвском шоссе 27',
                      address: 'Хорошёвское ш., 27',
                      workTime: 'Пн-Пт 10:00-21:00',
                      coords: [55.77923865906552, 37.52356959153274],
                      priceFormatted: '300 ₽',
                      price: '300',
                      typeText: 'Пункт выдачи заказа',
                      providerKeyText: "СДЭК"
                    },
                    {
                      id: '1003062714',
                      name: 'ТРЦ "Мозаика"',
                      address: 'ул, 7-я Кожуховская ул., 9 ТРЦ "Мозаика"',
                      workTime: 'Пн-Пт 10:00-20:00, Сб-Вс 10:00-18:00',
                      coords: [55.716468154586934, 37.6731217461949],
                      priceFormatted: '300 ₽',
                      price: '300',
                      typeText: 'Пункт выдачи заказа',
                      providerKeyText: "СДЭК"
                    },
                    {
                      id: '1003062715',
                      name: 'ТРЦ Columbus',
                      address: 'Кировоградская ул., 13А ТРЦ Columbus',
                      workTime: 'Пн-Пт 10:00-20:00, Сб-Вс 10:00-18:00',
                      coords: [55.6116990331495, 37.60723530006875],
                      priceFormatted: '300 ₽',
                      price: '300',
                      typeText: 'Пункт выдачи заказа',
                      providerKeyText: "СДЭК"
                    }
                  ]
                }
              });
            }, 2000)

          });
        }
      }
    });
  }

  function updateShopsPopupOnProfileSelect(cityObject, resetPoints) {
    return new Promise(function (resolve, reject) {
      if (window.popupShop && window.popupShop.showPreloader) {
        window.popupShop.showPreloader();
      }

      getAvailableShopsPoints(cityObject)
          .then(result => {
            if (result.status === 'success' && result.data.success) {
              window.checkout.shopsPoints = result.data.shopsPoints;
              window.checkout.updateShopsPopup(result.data.shopsPoints);

              if (window.popupShop && window.popupShop.resetSearch) {
                window.popupShop.resetSearch();
              }

              if (resetPoints) {
                window.checkout.resetPoint('shop')
              }
            }
            if (window.popupShop && window.popupShop.hidePreloader) {
              window.popupShop.hidePreloader();
            }

            resolve();
          })
          .catch(error => {
            if (window.popupShop && window.popupShop.hidePreloader) {
              window.popupShop.hidePreloader();
            }
            reject(error);
          })

      function getAvailableShopsPoints(cityObject) {
        let data = {};

        if (cityObject.id) {
          data = {
            id: cityObject.id
          }
        } else {
          data = {
            name: cityObject.name
          }
        }

        if (window.BX) {
          return window.BX.ajax.runComponentAction('ega:order', 'getShopPoints',
              {
                mode: 'class',
                data
              })
        } else {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve({
                status: 'success',
                data: {
                  success: true,
                  shopsPoints: [
                    {
                      id: '2003062711',
                      name: 'ТРЦ "Гранд Юг"',
                      address: 'ул. Кировоградская, д. 15, ТРЦ «Гранд Юг»',
                      workTime: 'Пн-Вс 10:00-21:00',
                      coords: [56.010233, 37.859322]
                    },
                    {
                      id: '2003062714',
                      name: 'ТРЦ "Мозаика"',
                      address: 'ул, 7-я Кожуховская ул., 9 ТРЦ "Мозаика"',
                      workTime: 'Пн-Пт 10:00-20:00, Сб-Вс 10:00-18:00',
                      coords: [55.716468154586934, 37.6731217461949]
                    },
                    {
                      id: '2003062715',
                      name: 'ТРЦ Columbus',
                      address: 'Кировоградская ул., 13А ТРЦ Columbus',
                      workTime: 'Пн-Пт 10:00-20:00, Сб-Вс 10:00-18:00',
                      coords: [55.6116990331495, 37.60723530006875]
                    }
                  ]
                }
              });
            }, 2000)

          });
        }
      }
    });
  }

  function setFirstDeliveryOrPayment(sType) {
    let sWrapContentAttr = sType;

    if (sType === 'payment')
      sWrapContentAttr = 'checkout-payment';

    document.querySelectorAll('[data-content=\'' + sWrapContentAttr + '\'] label:not(.m-hidden) [name=\'' + sType + '\']')[0]?.click();
  }

  function resetNodeErrors(oNode) {
    const errorElements = oNode.querySelectorAll('.ch-order__error');

    errorElements.forEach(oError => {
      oError.remove();
    });
  }

  function getRecalculatedBasket(paymentId)
  {
    window.BX.ajax.runComponentAction('ega:basket', 'recalculateBasket',
        {
          mode: 'class',
          data: {
            paymentId,
          },
        })
        .then((oResponse) => {
          if(oResponse.data.success)
          {
            let oTotalBlock = $('.order-total'),
                oEarnedBonus = oTotalBlock.find('#earnedBonus'),
                oCheckoutSale = oTotalBlock.find('#checkoutSale'),
                oCheckoutSumWithDiscount = oTotalBlock.find('#checkoutSumWithDiscount'),
                oPromocodeDiscount = oTotalBlock.find('#promocodeDiscount'),
                oCheckoutBonusBlock = oTotalBlock.find('#checkoutBonusBlock'),
                oCheckoutBonus = oTotalBlock.find('#checkoutBonus');

            for(let oBasketItemXmlId of Object.keys(oResponse.data.arResult.BASKET_ITEMS))
            {
              $('.order-total__param[data-id="' + oResponse.data.arResult.BASKET_ITEMS[oBasketItemXmlId].ID + '"]')
                  .find('.order-total__price').html(oResponse.data.arResult.BASKET_ITEMS[oBasketItemXmlId].PRICE_TOTAL_FORMATED).css('display', '').end()
                  .find('.discountPrice').html(oResponse.data.arResult.BASKET_ITEMS[oBasketItemXmlId].DISCOUNT_PRICE_FORMATED);

              if(oResponse.data.arResult.BASKET_ITEMS[oBasketItemXmlId].PRICE_TOTAL == oResponse.data.arResult.BASKET_ITEMS[oBasketItemXmlId].DISCOUNT_PRICE)
                $('.order-total__param[data-id="' + oResponse.data.arResult.BASKET_ITEMS[oBasketItemXmlId].ID + '"]').find('.order-total__price').html('').css('display', 'none');;
            }

            oCheckoutSumWithDiscount.html(!empty(oResponse.data.arResult.PRICE_WITH_DISCOUNT) ? oResponse.data.arResult.PRICE_WITH_DISCOUNT_FORMATED : '0 ₽');
            oCheckoutSale.html((!empty(oResponse.data.arResult.DISCOUNT_PRICE) ? '- ' : '') + oResponse.data.arResult.DISCOUNT_PRICE_FORMATED);
            oEarnedBonus.html(!empty(oResponse.data.arResult.EARNED_BONUS) ? '+ ' + oResponse.data.arResult.EARNED_BONUS + ' ₽' : '0 ₽');

            if(!oResponse.data.arResult.COUPON.CAN_BE_USED)
            {
              oPromocodeDiscount.html('0  ₽');
            }
            else
            {
              oPromocodeDiscount.html('- ' + oResponse.data.arResult.COUPON.DISCOUNT + ' ₽');
            }

            if(!empty(oResponse.data.arResult.POINTS))
            {
              if(oResponse.data.arResult.POINTS.CAN_BE_USED)
              {
                if (!empty(oResponse.data.arResult.POINTS.USED_POINTS_FORMATTED))
                {
                  oCheckoutBonus.html('- ' + oResponse.data.arResult.POINTS.USED_POINTS_FORMATTED + ' ₽');
                }
              }
              else
              {
                oCheckoutBonus.html(0);
              }
            }

            updateCheckoutTotalPrice();
          }
        })
  }

  function checkShowUserAgreementCheckbox(oPhoneInput, oOrderPromoAgreesNodes)
  {
    const oMakeOrderBtn = document.getElementById('make-order');
    const sCleanedPhoneNumber = oPhoneInput.value.replace(/\D/g, '');
    
    if (sCleanedPhoneNumber.length !== 11)
      return;

    window.BX.ajax.runComponentAction(
      'ega:order',
      'checkExistMbUser',
      {
        mode: 'class',
        data: {
          sPhone: sCleanedPhoneNumber
        },
      }
    ).then(({data: oResponse}) => {
      oOrderPromoAgreesNodes.forEach(oNode => {
        const oInputNode = oNode.querySelector('input[type="checkbox"]');

        if (oResponse.success && oResponse.bUserExist) {
          oNode.style.display = 'none';
          oInputNode.required = false;
          oMakeOrderBtn.disabled = false;
        } else {
          oNode.style.display = null;
          oInputNode.required = true;
          oMakeOrderBtn.disabled = true;
        }
      });
    });
  }

  function updatePaymentSchedules(sum)
  {
    if (!oPaymentSchedules.length)
      return;

    const oCurrentSelectedPayment = $('[name="payment"].radio:checked'),
        sCurrentSelectedPayment = oCurrentSelectedPayment.prop('id')
          ? oCurrentSelectedPayment.prop('id').replace(/ch-p-/gi, '')
          : '';

    oPaymentSchedules.forEach(oSchedule => {
      if (oSchedule.getAttribute('data-code') === sCurrentSelectedPayment)
      {
        const arPriceNodes = oSchedule.querySelectorAll('.payment-schedule__price'),
            iParts = arPriceNodes.length;

        if (iParts > 0 && sum > 0)
        {
          const iWholePart = Math.floor(sum / iParts),
              iRemainder = sum % iParts;

          arPriceNodes.forEach((oPriceNode, iIndex) => {
            oPriceNode.innerHTML = moneyFormat(iIndex === iParts - 1 ? iWholePart + iRemainder : iWholePart) + ' ₽';
          });
        }
      }
    });
  }

  function updateDeparturesBlock(arDepartures)
  {
    const oDeparturesBlock = document.querySelector('.ch-order__departures-block');

    if (!oDeparturesBlock) {
      return;
    }

    if (!Array.isArray(arDepartures) || arDepartures.length === 0) {
      oDeparturesBlock.style.display = 'none';
      return;
    }

    const oDeparturesWrap = oDeparturesBlock.querySelector('.ch-order__departures-wrap');

    oDeparturesWrap.replaceChildren();
    
    arDepartures.forEach(oDeparture => {
      const oDepartureWrap = document.createElement('div');
      oDepartureWrap.className = 'ch-order__departure';
      oDepartureWrap.id = `${oDeparture.CODE}-departure`;

      const oTitle = document.createElement('p');
      oTitle.className = 'ch-order__departure__title';
      oTitle.textContent = oDeparture.NAME || '';
      oDepartureWrap.appendChild(oTitle);

      if (oDeparture.DELIVERY_INFO && oDeparture.DELIVERY_INFO.length > 0) {
        const oDeliveryInfoP = document.createElement('p');
        oDeliveryInfoP.className = 'ch-order__departure__info';

        const oDeliveryInfoText = document.createTextNode(oDeparture.DELIVERY_INFO);
        oDeliveryInfoP.appendChild(oDeliveryInfoText);

        oDepartureWrap.appendChild(oDeliveryInfoP);
      }

      const oInfoP = document.createElement('p');
      oInfoP.className = 'ch-order__departure__info';

      const oInfoSpan = document.createElement('span');
      oInfoSpan.id = `${oDeparture.CODE}-departure-info`;
      oInfoSpan.textContent = oDeparture.INFO || '';
      oInfoP.appendChild(oInfoSpan);

      const oDotText = document.createTextNode(' · Срок доставки: ');
      oInfoP.appendChild(oDotText);

      const oDeliverySpan = document.createElement('span');
      oDeliverySpan.id = `${oDeparture.CODE}-departure-delivery-time`;
      oDeliverySpan.textContent = oDeparture.DELIVERY_TIME || '';
      oInfoP.appendChild(oDeliverySpan);

      oDepartureWrap.appendChild(oInfoP);

      const oProductsWrap = document.createElement('div');
      oProductsWrap.className = 'order-item__products';

      const oSliderOuter = document.createElement('div');
      oSliderOuter.className = 'order-item__product_slider swiper';

      const oSwiperWrapper = document.createElement('div');
      oSwiperWrapper.className = 'swiper-wrapper';

      if (Array.isArray(oDeparture.ITEMS)) {
        oDeparture.ITEMS.forEach(oProduct => {
          const oSlide = document.createElement('div');
          oSlide.className = 'swiper-slide';

          const oProductSlide = document.createElement('div');
          oProductSlide.className = 'product__slide';

          const oLink = document.createElement('a');
          oLink.href = oProduct.DETAIL_PAGE_URL || '#';
          oLink.target = '_blank';

          const oImg = document.createElement('img');
          oImg.className = 'image';
          oImg.src = oProduct.PREVIEW_PICTURE_SRC_2X || '';
          oImg.alt = oProduct.NAME || '';
          oLink.appendChild(oImg);

          const oNameP = document.createElement('p');
          oNameP.className = 'product__name';
          oNameP.textContent = oProduct.NAME || '';
          oLink.appendChild(oNameP);

          oProductSlide.appendChild(oLink);

          const oPriceDiv = document.createElement('div');
          oPriceDiv.className = 'cart-item__prices cart-item__prices--left';

          if (oProduct.DISCOUNT_PRICE !== null && oProduct.PRICE !== null && (oProduct.DISCOUNT_PRICE != oProduct.PRICE)) {
            const oOldSpan = document.createElement('span');
            oOldSpan.className = 'cart-item__price product__price m-old';
            oOldSpan.textContent = oProduct.PRICE_FORMATED || '';
            oPriceDiv.appendChild(oOldSpan);

            const oNewSpan = document.createElement('span');
            oNewSpan.className = 'cart-item__price product__price';
            oNewSpan.textContent = oProduct.DISCOUNT_PRICE_FORMATED || '';
            oPriceDiv.appendChild(oNewSpan);
          } else {
            const oOnlySpan = document.createElement('span');
            oOnlySpan.className = 'cart-item__price product__price';
            oOnlySpan.textContent = oProduct.DISCOUNT_PRICE_FORMATED || oProduct.PRICE_FORMATED || '';
            oPriceDiv.appendChild(oOnlySpan);
          }
          oProductSlide.appendChild(oPriceDiv);

          const oBottom = document.createElement('div');
          oBottom.className = 'product__bottom-params';

          if (oProduct.COLOR_HEX) {
            const oColorDiv = document.createElement('div');
            oColorDiv.className = 'cart-item__param product__color';
            oColorDiv.style.backgroundColor = oProduct.COLOR_HEX;
            oColorDiv.title = oProduct.TSVETSAYT || '';
            oBottom.appendChild(oColorDiv);
          }

          const oSizeDiv = document.createElement('div');
          oSizeDiv.className = 'cart-item__param product__size';

          const oDt = document.createElement('dt');
          oDt.innerHTML = 'Размер&nbsp;';
          oSizeDiv.appendChild(oDt);

          const oDd = document.createElement('dd');
          oDd.textContent = oProduct.SIZE || '';
          oSizeDiv.appendChild(oDd);

          oBottom.appendChild(oSizeDiv);

          oProductSlide.appendChild(oBottom);

          oSlide.appendChild(oProductSlide);
          oSwiperWrapper.appendChild(oSlide);
        });
      }

      oSliderOuter.appendChild(oSwiperWrapper);
      oProductsWrap.appendChild(oSliderOuter);
      oDepartureWrap.appendChild(oProductsWrap);

      oDeparturesWrap.appendChild(oDepartureWrap);

      new Swiper(oSliderOuter, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        centeredSlidesBounds: true,
        watchSlidesProgress: true
      });
    });

    oDeparturesBlock.style.display = 'block';
  }
});
